import { Button, Flex, Text } from '@radix-ui/themes'

import { useJourney } from '../../journey'

import { chileautosHighlightsPhoneSpec } from './journey'
import { MobileSimulator } from './MobileSimulator'
import { Headline, Kicker, Note, StepList } from './Story'

import type { AnnouncementProps } from '../types'

/*
La versión de teléfono: una sola columna, con el título arriba, el recorrido
al medio y los pasos debajo. El número del paso viaja con la leyenda del
recorrido, para que el orden se vea aunque los pasos queden fuera de la
pantalla.

El alto se limita para que "Entendido" quede fijo abajo, al alcance del pulgar,
mientras lo demás se desliza: 10rem cubren el encabezado del anuncio y el
margen que el diálogo deja arriba y abajo.
*/
export const MobileBody = ({ active, onDismiss }: AnnouncementProps) => {
  const journey = useJourney(chileautosHighlightsPhoneSpec, active)

  return (
    <div className="flex max-h-[calc(100dvh-10rem)] flex-col">
      <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-4 pb-5 pt-4">
        <Kicker />
        <Headline className="text-[19px] leading-tight" />
        <p className="mt-1.5 text-[13px] leading-relaxed text-[#706d71]">
          Premium, TopSpot, Showcase y TopNitro, aviso por aviso.{' '}
          <strong className="font-semibold text-[#1c1917]">Primero, un administrador tiene que dar el permiso.</strong>
        </p>

        <Flex align="center" gap="2" className="mb-2 mt-4">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#107c41] opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-[#107c41]" />
          </span>
          <span className="font-mono text-[10px] font-bold uppercase tracking-wider text-[#107c41]">
            Simulación en tiempo real
          </span>
        </Flex>

        <MobileSimulator state={journey} />

        <Flex align="center" gap="2" className="mt-2.5 min-h-[20px]">
          <span
            className="vk-step-num transition-opacity"
            data-solid
            style={{ opacity: journey.step ? 1 : 0 }}
            aria-hidden
          >
            {journey.step ?? ''}
          </span>
          <span className="text-[12px] leading-snug text-[#57534e]">{journey.caption}</span>
        </Flex>

        <div className="mt-4">
          <StepList active={journey.step} size="phone" />
        </div>
        <div className="mt-3">
          <Note size="phone" />
        </div>
      </div>

      <div className="shrink-0 border-t border-[#e4e1e4] px-4 py-3">
        <Button size="3" color="red" onClick={onDismiss} style={{ width: '100%' }}>
          <Text weight="bold">Entendido</Text>
        </Button>
      </div>
    </div>
  )
}
